export enum PromotionEntryTemplateSearchTypes {
    CustomerId = "CustomerId",
    CustomerName = "CustomerName",
    ItemNumber = "ItemNumber",
    ProductLineNumber = "ProductLineNumber",
    ProductLineCategoryNumber = "ProductLineCategoryNumber",
    PromotionId = "PromotionId",
    PromotionDescription = "PromotionDescription",
    TemplateId = "TemplateId",
};
